<template>
  <b-modal
    id="modal-contingency"
    title="Seleccione un motivo"
    size='md'
    hide-footer
  >
    <div class="row">
      <div class="col-sm-12">
        <multiselect2
          v-model="tipoContingenciaSelected"
          :options="tipoContingencias"
          placeholder="Motivo"
          label="descripcion"
          track-by="id"
          select-label=""
          deselect-label="X"
          :allow-empty="false"
          @select="selectItem"
        >
        </multiselect2>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect2 from '@/components/util/vue-multiselect2';

export default {
  name: 'modalContingency',
  components: {
    Multiselect2,
  },
  props: {
    tipoContingencias: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      tipoContingenciaSelected: null,
    };
  },
  methods: {
    selectItem(item) {
      if (item) {
        this.$emit('selectMotivoContingencia', item);
        this.$bvModal.hide('modal-contingency');
        this.tipoContingenciaSelected = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-template {
  text-align: left;
  font-size: 12px;
  margin: 0px 5px;
  &, & > div {
    box-sizing: border-box;
  }
  border: 1px solid #ffefc5;
}
.background-title {
  background-color: #fef4d1
}
.content {
  background-color: #fff9e8;
  .text-level {
    color: #9f8034
  }
  .text-siat {
    color: black
  }
}
</style>
